// do not modify this file
import Animate from './src/Animate';
export CSSMotion from './src/CSSMotion';
export CSSMotionList from './src/CSSMotionList';
export default Animate;



// WEBPACK FOOTER //
// ./index.js